module.exports = __webpack_public_path__ + "static/media/html5.f2282f94.png";